module.exports = __webpack_public_path__ + "static/media/edit.91b2d5a3.svg";